import React from 'react'
import './Body.css'
import Home from'./Body/Home'
import About from'./Body/About'
import Services from'./Body/Services'
import Portfolio from'./Body/Portfolio'
import Contact from'./Body/Contact'

function Body() {
    return (
        <div className="body">
            <Home />
            <About />
            <Services />
            <Portfolio />
            <Contact />
        </div>
    )
}

export default Body
